import { dtoErrors } from '@hulanbv/toftennis/distribution/constants/dto-errors.constant';
import { dictionary } from '@hulanbv/dashboard-components/distribution/domain/constants/dictionary.constants';

export const translatePackages = (): void => {
  /**
   * translate component labels
   */
  // literals
  dictionary.literals.ascending = 'Oplopend';
  dictionary.literals.cancel = 'Annuleren';
  dictionary.literals.confirm = 'Bevestigen';
  dictionary.literals.delete = 'Verwijder';
  dictionary.literals.descending = 'Aflopend';
  dictionary.literals.next = 'Volgende';
  dictionary.literals.previous = 'Vorige';
  dictionary.literals.save = 'Opslaan';
  dictionary.literals.search = 'Zoeken';
  dictionary.literals.sort = 'Sorteren';

  // dynamics
  dictionary.dynamics.showingXToYOfZResults = (
    from?: number,
    to?: number,
    total?: number,
  ): string => `${from ?? '-'} tot ${to ?? '-'} van ${total ?? '-'} resultaten`;
  const isNotEmptyMessage = 'Deze waarde mag niet leeg zijn';
  const isStringMessage = 'Deze waarde moet een tekst bevatten';
  const isMongoIdMessage = 'Deze waarde refereert naar een onbestaand object';
  const isEmailMessage = 'Deze waarde moet een geldig e-mailadres bevatten';

  /**
   * Translate data transfer object errors
   */
  // translate club errors
  dtoErrors.club.address.isNotEmpty = isNotEmptyMessage;
  dtoErrors.club.address.isString = isStringMessage;
  dtoErrors.club.city.isNotEmpty = isNotEmptyMessage;
  dtoErrors.club.city.isString = isStringMessage;
  dtoErrors.club.name.isNotEmpty = isNotEmptyMessage;
  dtoErrors.club.name.isString = isStringMessage;
  dtoErrors.club.phone.isNotEmpty = isNotEmptyMessage;
  dtoErrors.club.phone.isString = isStringMessage;
  dtoErrors.club.state.isNotEmpty = isNotEmptyMessage;
  dtoErrors.club.state.isString = isStringMessage;
  dtoErrors.club.zipCode.isNotEmpty = isNotEmptyMessage;
  dtoErrors.club.zipCode.isString = isStringMessage;

  // translate credential errors
  dtoErrors.credentials.username.isNotEmpty = isNotEmptyMessage;
  dtoErrors.credentials.username.isString = isStringMessage;
  dtoErrors.credentials.password.isNotEmpty = isNotEmptyMessage;
  dtoErrors.credentials.password.isString = isStringMessage;

  // translate group errors
  dtoErrors.group.clubId.isMongoId = isMongoIdMessage;
  dtoErrors.group.instructorIds.isMongoId = isMongoIdMessage;
  dtoErrors.group.memberIds.isMongoId = isMongoIdMessage;
  dtoErrors.group.name.isNotEmpty = isNotEmptyMessage;
  dtoErrors.group.name.isString = isStringMessage;

  // translate user errors
  dtoErrors.user.email.isEmail = isEmailMessage;
  dtoErrors.user.email.isNotEmpty = isNotEmptyMessage;
  dtoErrors.user.firstName.isNotEmpty = isNotEmptyMessage;
  dtoErrors.user.firstName.isString = isStringMessage;
  dtoErrors.user.preposition.isString = isStringMessage;
  dtoErrors.user.lastName.isNotEmpty = isNotEmptyMessage;
  dtoErrors.user.lastName.isString = isStringMessage;
  dtoErrors.user.password.isNotEmpty = isNotEmptyMessage;
  dtoErrors.user.password.isString = isStringMessage;
  dtoErrors.user.phoneNumber.isString = isStringMessage;
  dtoErrors.user.role.isEnum = 'Deze rol is ongeldig';
  dtoErrors.user.username.isNotEmpty = isNotEmptyMessage;
  dtoErrors.user.username.isString = isStringMessage;
};
